module.exports = __webpack_public_path__ + "static/img/brees-2008-slide-6.eccff99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2008-slide-6.jpg
// module id = C/pk
// module chunks = 1